/**
 * Debug logging utility that only logs when debug=true is in the URL
 */

const isDebugMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('debug') === 'true';
};

export const debugLog = (...args) => {
  if (isDebugMode()) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (isDebugMode()) {
    console.warn(...args);
  }
};

export const debugError = (...args) => {
  if (isDebugMode()) {
    console.error(...args);
  }
};

export const debugInfo = (...args) => {
  if (isDebugMode()) {
    console.info(...args);
  }
};
